import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _jsxFileName = "/Users/brentvatne/code/react-native-appearance/src/index.tsx";
import React, { useMemo } from 'react';
import NativeEventEmitter from "react-native-web/dist/exports/NativeEventEmitter";
import { EventEmitter } from 'fbemitter';
import { useSubscription } from 'use-subscription';
export * from "./Appearance.types";
import { NativeAppearance, NativeAppearanceProvider } from "./NativeAppearance";
var eventEmitter = new EventEmitter();
var appearancePreferences = NativeAppearance.initialPreferences;
var nativeEventEmitter = new NativeEventEmitter(NativeAppearance);
nativeEventEmitter.addListener('appearanceChanged', function (newAppearance) {
  Appearance.set(newAppearance);
});
export var Appearance = function () {
  function Appearance() {
    _classCallCheck(this, Appearance);
  }

  _createClass(Appearance, null, [{
    key: "getColorScheme",
    value: function getColorScheme() {
      return appearancePreferences.colorScheme;
    }
  }, {
    key: "set",
    value: function set(preferences) {
      var colorScheme = preferences.colorScheme;

      if (appearancePreferences.colorScheme !== colorScheme) {
        appearancePreferences = {
          colorScheme: colorScheme
        };
        eventEmitter.emit('change', preferences);
      }
    }
  }, {
    key: "addChangeListener",
    value: function addChangeListener(listener) {
      return eventEmitter.addListener('change', listener);
    }
  }]);

  return Appearance;
}();
export var AppearanceProvider = function AppearanceProvider(props) {
  return React.createElement(NativeAppearanceProvider, _extends({
    style: {
      flex: 1
    }
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70
    }
  }));
};
export function useColorScheme() {
  var subscription = useMemo(function () {
    return {
      getCurrentValue: function getCurrentValue() {
        return Appearance.getColorScheme();
      },
      subscribe: function subscribe(callback) {
        var eventSubscription = Appearance.addChangeListener(callback);
        return function () {
          return eventSubscription.remove();
        };
      }
    };
  }, []);
  return useSubscription(subscription);
}